import { ytVueGlobalStore } from "@/services/yt-vue-global-store";

const page404 = ytVueGlobalStore.instantGet('page404');
export default {
  namespaced: true,
  state: {
    ...page404,
  },
};
